<template>
  <v-row>
    <v-col>
      <v-expansion-panel-content>
        <v-row>
          <!--          <v-col-->
          <!--            cols="6"-->
          <!--            sm="4"-->
          <!--            md="2"-->
          <!--          >-->
          <!--            <v-text-field-->
          <!--              v-model="screen.order"-->
          <!--              label="Порядковый номер экрана"-->
          <!--              type="number"-->
          <!--            />-->
          <!--          </v-col>-->
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.toolbar"
              label="Цвет тулбара"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo"
              label="Логотип"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoWidth"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoHeight"
              label="Высота изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-checkbox
              v-model="screen.logo_only"
              label="Изображение - во весь экран"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo2"
              label="Иконка удаления товара"
              :btn_text="'Иконка удаления товара'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo2Width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo2Height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Текст над списком товаров
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.text.text"
              label="Текст"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Список товаров
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text2.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text2.color"
              label="Цвет шрифта"
            />
          </v-col>
          <!--          <v-col-->
          <!--              cols="12"-->
          <!--              md="12"-->
          <!--          >-->
          <!--            <v-textarea-->
          <!--                v-model="screen.text.text"-->
          <!--                label="Текст"-->
          <!--                type="text"-->
          <!--            />-->
          <!--          </v-col>-->
        </v-row>
        <v-row>
          <v-col cols="12">
            Текст Итого
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text3.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text3.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.text3.text"
              label="Текст"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <strong>Кнопка Отмена</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.button.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button.label"
              label="Кнопка Отмена"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <strong>Кнопка Оплатить</strong>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="screen.button2.radius"
                label="Размер радиуса"
                type="number"
              />
            </v-col>
            <v-text-field
              v-model="screen.button2.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button2.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button2.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button2.label"
              label="Кнопка Оплатить"
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-col>
  </v-row>
</template>

<style>

</style>
<script>
import { posPointBucketScreen } from "@/views/loyalty/models/justpay-configuration-interface.model"

export default {
  name: 'SetupPospointBucketScreen',
  model: {
    prop: "screen",
    event: "changeScreen",
  },
  props: {
    confType: {
      type: Number,
      default: 0
    },
    screen: {
      default: () => (posPointBucketScreen)
    },
  },
  watch: {
    screen () {
      this.$emit('changeScreen', this.screen)
    }
  },
}
</script>
